const book = {
  originPathTips: "วิถีเดิม",
  sharpturn: "เลี้ยวหักศอก",
  emergencyBrake: "เบรกฉุกเฉิน",
  rapidAcceleration: "การเร่งความเร็วอย่างรวดเร็ว",
  sharpturnCount: "เลี้ยวกะทันหัน (ครั้ง)",
  emergencyBrakeCount: "เบรคกะทันหัน (ครั้ง)",
  rapidAccelerationCount: "เร่งกะทันหัน (ครั้ง)",
  overSpeedCount: "ความเร็วเกินกำหนด (ครั้ง)",
  tripMaxSpeed: "ความเร็วสูงสุด (ก.ม./ชั่วโมง)",
  tripAvgSpeed: "ความเร็วเฉลี่ย (ก.ม./ชั่วโมง)",
  emergencyBrakeWidth: "200px",
  rapidAccelerationWidth: "200px",
  sharpturnWidth: "200px",
  oil: "ปริมาณการใช้น้ำมัน (L)",
  oilNodw: "ค่าน้ำมัน",
  oilCost: "ค่าน้ำมัน (บาท)",
  carbon: "ปริมาณคาร์บอน (ก.ก.)",
  tip: "Cancel the trip",
  public: "Public",
  selfDriving: "Self driving",
  view: "ดูรายละเอียดแผนการเดินทาง",
  endAddress: "สถานที่สิ้นสุด",
  adminCancelRes: "Administrator cancellation reason",
  orderNumber: "Order NO",
  startOfJourney: "จุดเริ่มต้น",
  endOfTrip: "จุดสิ้นสุด",
  appointmentStatus: "Order status",
  travelTime: "เวลา",
  startingPlace: "ตำแหน่งเริ่มต้น",
  itineraryInformation: "ข้อมูลแผนการเดินทาง",
  vehicleInformation: "ข้อมูลยานพาหนะ",
  vehicleUseApproval: "พฤติกรรมการขับรถ",
  vehicleUseApprovalScore: "คะแนนพฤติกรรมการขับรถ",
  historicalTrack: "ติดตามประวัติศาสตร์",
  searchLabelWidth: {
    width1: "90px",
    width2: "80px",
    width3: "140px",
    width4: "120px"
  },
  searchWidth: "100px",
  vehiclePersonnel: "Trip user",
  driver: "Driver",
  brand: "ยี่ห้อ",
  orderTime: "Order time",
  cancelNotes: "Cancel reason",
  model: "โมเดล",
  series: "ซีรี่ย์",
  mileage: "ระยะทาง",
  drivingBehaviorScore: "คะแนน",
  aperationMileage: "ระยะทาง (กม.)",
  aperationTiemLenthen: "เวลา (นาที)",
  useAdmin: "ผู้ใช้ V2X",
  labelWidth: {
    orderNumber: "180px",
    orderTime: "180px",
    licensePlate: "200px",
    startOfJourney: "260px",
    endOfTrip: "180px",
    appointmentStatus: "180px",
    vehiclePersonnel: "170px",
    brand: "100px",
    startTime: "150px",
    endTime: "150px",
    note: "100px"
  },
  leftWidth: "130px",
  rightWidth: "140px",
  pass: "Pass",
  notpass: "Not pass",
  error: "กรุณากรอกความคิดเห็น",
  toBeAudited: "Pending",
  toBeReported: "Waiting to go",
  auditFailed: "Rejected",
  cancelReservation: "Cancel",
  adminCancel: "Master cancel",
  completed: "Completed",
  toBeReportedbyReturn: "Waiting to return",
  auditPass: "Passed",
  processing: "Processing",
  cancel: "Cancel reservation",
  error2: "Please enter comments",
  success: "Cancellation of success",
  labelWidth1: "140px",
  historyTrack: {
    playbackSpeed: "ความเร็วในการเล่น",
    playbackTrack: "Playback of thack",
    enter: "ป้อน",
    exit: "ออก",
    progress: "ความคืบหน้าของการเล่น",
    error: {
      msg1: "Please search the data after exit the play",
      msg2: "Please select start time and end time",
      msg3: "Start time cannot be later than end time， please reselect it",
      msg4: "You can only search data within 7 days",
      msg5: "ไม่มีข้อมูลการติดตามในอดีต"
    },
    noData: "ไม่มีข้อมูล"
  }
} 
export default book